import { useBreakpoint } from '@qr-front/ui/hooks'
import { useEffect } from 'react'

const setStyles = (
	overflow: string,
	pointerEvents: string,
	refs: NodeListOf<HTMLElement>,
	excludeSelector?: string,
) => {
	document.body.style.overflow = overflow
	refs.forEach((el) => {
		if (excludeSelector) {
			const excludedElements = document.querySelectorAll(excludeSelector)
			const isExcluded = Array.from(excludedElements).some(
				(excluded) =>
					excluded.contains(el) || excluded === el || el.contains(excluded),
			)
			if (isExcluded) {
				return
			}
		}

		if (overflow === 'hidden') {
			el.style.setProperty('overflow', 'hidden', 'important')
			el.style.setProperty('pointer-events', pointerEvents, 'important')
		} else {
			el.style.removeProperty('overflow')
			el.style.removeProperty('pointer-events')
		}
	})
}

export const useScrollLock = ({
	isOpen,
	idSelector,
	excludeSelector,
}: {
	isOpen: boolean
	idSelector?: string
	excludeSelector?: string
}) => {
	const isDesktop = useBreakpoint('desktop')

	useEffect(() => {
		const finalSelector = isDesktop
			? idSelector || 'main'
			: idSelector || 'body'
		const rafId = requestAnimationFrame(() => {
			const containers = document.querySelectorAll<HTMLElement>(finalSelector)

			if (isOpen) {
				setStyles('hidden', 'none', containers, excludeSelector)
			} else {
				setStyles('', 'auto', containers, excludeSelector)
			}
		})

		return () => {
			cancelAnimationFrame(rafId)
			const containers = document.querySelectorAll<HTMLElement>(finalSelector)
			setStyles('', 'auto', containers, excludeSelector)
		}
	}, [isOpen, idSelector, excludeSelector, isDesktop])
}
